export default "__VITE_ASSET__Dt$GT5Nd__"